import { Pipe, PipeTransform } from '@angular/core';

import { CroisementÉtat } from '../models/croisement-état';

@Pipe({
  name: 'convertEtatToString',
})
export class ConvertEtatToStringPipe implements PipeTransform {
  transform(value?: CroisementÉtat): string {
    if (!value) {
      return '';
    }
    switch (value) {
      case CroisementÉtat.A_FAIRE:
        return 'À Faire';
      case CroisementÉtat.EN_COURS:
        return 'En cours';
      case CroisementÉtat.TERMINE:
        return 'Terminé';
    }
  }
}
